/* eslint-disable indent */
export const updateMessages = (messages, response, newAiMessage) => {
    const messageWithQuote = messages.filter((msg) => msg.type === 'ai' && msg.quote !== null);
    const meesagesWithAccident = messages.filter((msg) => msg.type === 'ai' && msg.accident !== null);
    const messagesWithSuspension = messages.filter((msg) => msg.type === 'ai' && msg.suspension !== null);
    const messagesWithReplacement = messages.filter((msg) => msg.type === 'ai' && msg.replacement !== null);
    const messagesWithCancellation = messages.filter((msg) => msg.type === 'ai' && msg.cancellation !== null);
    const messagesWithModifyData = messages.filter((msg) => msg.type === 'ai' && msg.modifyData !== null);
    const messagesWithNewQuote = messages.filter((msg) => msg.type === 'ai' && msg.newQuote !== null);
    const messagesWithErrorNewQuote = messages.filter((msg) => msg.type === 'ai' && msg.errorNewQuote !== null);
    const messagesWithProfessionQuote = messages.filter((msg) => msg.type === 'ai' && msg.professionQuote !== null);
    const messagesWithCommercialQuote = messages.filter((msg) => msg.type === 'ai' && msg.commercialQuote !== null);
    const messagesWithTravelQuote = messages.filter((msg) => msg.type === 'ai' && msg.travelQuote !== null);
    const messagesWithProfessioniSanitaQuote = messages.filter((msg) => msg.type === 'ai' && msg.professioniSanitaQuote !== null);
    const messagesWithMediciDipendentiQuote = messages.filter((msg) => msg.type === 'ai' && msg.mediciDipendentiQuote !== null);
    const messagesWithMedicoProtettoQuote = messages.filter((msg) => msg.type === 'ai' && msg.medicoProtettoQuote !== null);
    const messagesWithMedicoLiberoProfessionistaQuote = messages.filter((msg) => msg.type === 'ai' && msg.medicoLiberoProfessionistaQuote !== null);
    const messagesWithHouseQuote = messages.filter((msg) => msg.type === 'ai' && msg.houseQuote !== null);
    const messagesWithCondominioQuote = messages.filter((msg) => msg.type === 'ai' && msg.condominioQuote !== null);
    const messagesWithRcFamigliaQuote = messages.filter((msg) => msg.type === 'ai' && msg.rcFamigliaQuote !== null);

    if (messageWithQuote.length === 0) {
        newAiMessage.quote = response.data.quote || null;
    } else {
        for (let x = 0; x < messageWithQuote.length; x++) {
            const msg = messageWithQuote[x];
            if (msg.quote && JSON.stringify(msg.quote) !== JSON.stringify(response.data.quote)) {
                newAiMessage.quote = msg.quote;
            }
        }
    }

    if (meesagesWithAccident.length === 0) {
        newAiMessage.accident = response.data.newAccident || null;
    } else {
        for (let x = 0; x < meesagesWithAccident.length; x++) {
            const msg = meesagesWithAccident[x];
            if (msg.accident && JSON.stringify(msg.accident) !== JSON.stringify(response.data.newAccident)) {
                newAiMessage.accident = msg.newAccident;
            }
        }
    }

    if (messagesWithSuspension.length === 0) {
        newAiMessage.suspension = response.data.newSuspension || null;
    } else {
        for (let x = 0; x < messagesWithSuspension.length; x++) {
            const msg = messagesWithSuspension[x];
            if (msg.suspension && JSON.stringify(msg.suspension) !== JSON.stringify(response.data.newSuspension)) {
                newAiMessage.suspension = msg.newSuspension;
            }
        }
    }

    if (messagesWithReplacement.length === 0) {
        newAiMessage.replacement = response.data.newReplacement || null;
    } else {
        for (let x = 0; x < messagesWithReplacement.length; x++) {
            const msg = messagesWithReplacement[x];
            if (msg.replacement && JSON.stringify(msg.replacement) !== JSON.stringify(response.data.newReplacement)) {
                newAiMessage.replacement = msg.newReplacement;
            }
        }
    }

    if (messagesWithCancellation.length === 0) {
        newAiMessage.cancellation = response.data.newCancellation || null;
    } else {
        for (let x = 0; x < messagesWithCancellation.length; x++) {
            const msg = messagesWithCancellation[x];
            if (msg.cancellation && JSON.stringify(msg.cancellation) !== JSON.stringify(response.data.newCancellation)) {
                newAiMessage.cancellation = msg.newCancellation;
            }
        }
    }

    if (messagesWithModifyData.length === 0) {
        newAiMessage.modification = response.data.newModifyData || null;
    } else {
        for (let x = 0; x < messagesWithModifyData.length; x++) {
            const msg = messagesWithModifyData[x];
            if (msg.modification && JSON.stringify(msg.modification) !== JSON.stringify(response.data.newModifyData)) {
                newAiMessage.modification = msg.newModifyData;
            }
        }
    }

    if (messagesWithErrorNewQuote.length === 0) {
        newAiMessage.errorNewQuote = response.data.errorNewQuote || null;
    } else {
        for (let x = 0; x < messagesWithErrorNewQuote.length; x++) {
            const msg = messagesWithErrorNewQuote[x];
            if (msg.errorNewQuote && JSON.stringify(msg.errorNewQuote) !== JSON.stringify(response.data.errorNewQuote)) {
                newAiMessage.errorNewQuote = msg.errorNewQuote;
            }
        }
    }

    if (messagesWithNewQuote.length === 0) {
        newAiMessage.newQuote = response.data.newQuote || null;
    } else {
        for (let x = 0; x < messagesWithNewQuote.length; x++) {
            const msg = messagesWithNewQuote[x];
            if (msg.newQuote && JSON.stringify(msg.newQuote) !== JSON.stringify(response.data.newQuote)) {
                newAiMessage.newQuote = msg.newQuote;
            }
        }
    }

    if (messagesWithProfessionQuote.length === 0) {
        newAiMessage.professionQuote = response.data.professionQuote || null;
    } else {
        for (let x = 0; x < messagesWithProfessionQuote.length; x++) {
            const msg = messagesWithProfessionQuote[x];
            if (msg.professionQuote && JSON.stringify(msg.professionQuote) !== JSON.stringify(response.data.professionQuote)) {
                newAiMessage.professionQuote = msg.professionQuote;
            }
        }
    }

    if (messagesWithCommercialQuote.length === 0) {
        newAiMessage.commercialQuote = response.data.commercialQuote || null;
    } else {
        for (let x = 0; x < messagesWithCommercialQuote.length; x++) {
            const msg = messagesWithCommercialQuote[x];
            if (msg.commercialQuote && JSON.stringify(msg.commercialQuote) !== JSON.stringify(response.data.commercialQuote)) {
                newAiMessage.commercialQuote = msg.commercialQuote;
            }
        }
    }

    if (messagesWithTravelQuote.length === 0) {
        newAiMessage.travelQuote = response.data.travelQuote || null;
    } else {
        for (let x = 0; x < messagesWithTravelQuote.length; x++) {
            const msg = messagesWithTravelQuote[x];
            if (msg.travelQuote && JSON.stringify(msg.travelQuote) !== JSON.stringify(response.data.travelQuote)) {
                newAiMessage.travelQuote = msg.travelQuote;
            }
        }
    }

    if (messagesWithProfessioniSanitaQuote.length === 0) {
        newAiMessage.professioniSanitaQuote = response.data.professioniSanitaQuote || null;
    } else {
        for (let x = 0; x < messagesWithProfessioniSanitaQuote.length; x++) {
            const msg = messagesWithProfessioniSanitaQuote[x];
            if (msg.professioniSanitaQuote && JSON.stringify(msg.professioniSanitaQuote) !== JSON.stringify(response.data.professioniSanitaQuote)) {
                newAiMessage.professioniSanitaQuote = msg.professioniSanitaQuote;
            }
        }
    }

    if (messagesWithMediciDipendentiQuote.length === 0) {
        newAiMessage.mediciDipendentiQuote = response.data.mediciDipendentiQuote || null;
    } else {
        for (let x = 0; x < messagesWithMediciDipendentiQuote.length; x++) {
            const msg = messagesWithMediciDipendentiQuote[x];
            if (msg.mediciDipendentiQuote && JSON.stringify(msg.mediciDipendentiQuote) !== JSON.stringify(response.data.mediciDipendentiQuote)) {
                newAiMessage.mediciDipendentiQuote = msg.mediciDipendentiQuote;
            }
        }
    }

    if (messagesWithMedicoProtettoQuote.length === 0) {
        newAiMessage.medicoProtettoQuote = response.data.medicoProtettoQuote || null;
    } else {
        for (let x = 0; x < messagesWithMedicoProtettoQuote.length; x++) {
            const msg = messagesWithMedicoProtettoQuote[x];
            if (msg.medicoProtettoQuote && JSON.stringify(msg.medicoProtettoQuote) !== JSON.stringify(response.data.medicoProtettoQuote)) {
                newAiMessage.medicoProtettoQuote = msg.medicoProtettoQuote;
            }
        }
    }

    if (messagesWithMedicoLiberoProfessionistaQuote.length === 0) {
        newAiMessage.medicoLiberoProfessionistaQuote = response.data.medicoLiberoProfessionistaQuote || null;
    } else {
        for (let x = 0; x < messagesWithMedicoLiberoProfessionistaQuote.length; x++) {
            const msg = messagesWithMedicoLiberoProfessionistaQuote[x];
            if (msg.medicoLiberoProfessionistaQuote && JSON.stringify(msg.medicoLiberoProfessionistaQuote) !== JSON.stringify(response.data.medicoLiberoProfessionistaQuote)) {
                newAiMessage.medicoLiberoProfessionistaQuote = msg.medicoLiberoProfessionistaQuote;
            }
        }
    }

     if (messagesWithHouseQuote.length === 0) {
        newAiMessage.houseQuote = response.data.houseQuote || null;
    } else {
        for (let x = 0; x < messagesWithHouseQuote.length; x++) {
            const msg = messagesWithHouseQuote[x];
            if (msg.houseQuote && JSON.stringify(msg.houseQuote) !== JSON.stringify(response.data.houseQuote)) {
                newAiMessage.houseQuote = msg.houseQuote;
            }
        }
    }

     if (messagesWithCondominioQuote.length === 0) {
        newAiMessage.condominioQuote = response.data.condominioQuote || null;
    } else {
        for (let x = 0; x < messagesWithCondominioQuote.length; x++) {
            const msg = messagesWithCondominioQuote[x];
            if (msg.condominioQuote && JSON.stringify(msg.condominioQuote) !== JSON.stringify(response.data.condominioQuote)) {
                newAiMessage.condominioQuote = msg.condominioQuote;
            }
        }
    }

     if (messagesWithRcFamigliaQuote.length === 0) {
        newAiMessage.rcFamigliaQuote = response.data.rcFamigliaQuote || null;
    } else {
        for (let x = 0; x < messagesWithRcFamigliaQuote.length; x++) {
            const msg = messagesWithRcFamigliaQuote[x];
            if (msg.rcFamigliaQuote && JSON.stringify(msg.rcFamigliaQuote) !== JSON.stringify(response.data.rcFamigliaQuote)) {
                newAiMessage.rcFamigliaQuote = msg.rcFamigliaQuote;
            }
        }
    }
};
